import { render, staticRenderFns } from "./ActivityItem.vue?vue&type=template&id=e897ac02&scoped=true&"
import script from "./ActivityItem.vue?vue&type=script&lang=js&"
export * from "./ActivityItem.vue?vue&type=script&lang=js&"
import style0 from "./ActivityItem.vue?vue&type=style&index=0&id=e897ac02&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e897ac02",
  null
  
)

export default component.exports